import React, { useEffect } from "react";

import dayjs from "dayjs";
import AccessCollinsLogo from "../../../../assets/logos/access_Collins_RedAndWhite.svg";
import AccessCollinsLogoBlack from "../../../../assets/logos/access_Collins_RedAndBlack.svg";
import { useDeviceContext } from "../../../../context/DeviceContext";
import { initialiseAccessButton } from "@workspace/access-button-launcher";
import { dmnIdentity } from "../../../../utils/dmnIdentity";
import {
  getEnvironmentProps,
  isNativeTab
} from "../../../../utils/environment";
import { getButtonToken } from "../../../../APIs/Utils/GetEvoToken";

export const AccessHeaderLogo = () => {
  const {
    lastSyncForDate,
    colourScheme,
    connectionStatus,
    isAccessButtonEnabled
  } = useDeviceContext();
  const lastSyncForOfflineIndicator = lastSyncForDate
    ? dayjs(lastSyncForDate).format("HH:mm")
    : "Unknown";

  useEffect(() => {
    (async () => {
      if (!isAccessButtonEnabled) {
        return;
      }

      const token = await dmnIdentity.getAccessToken();
      const environmentProps = getEnvironmentProps(token) ?? null;

      if (!environmentProps) {
        return;
      }

      initialiseAccessButton({
        inWorkspace: false,
        // colourScheme: colourScheme, // Dark mode appears to not work fully with the Access button yet
        environment: environmentProps.ACCESS_BTN_ENV,
        positions: {
          parentElement: "#access_button",
          desktop: {
            left: 12
          }
        },
        closedZindex: 1,
        getToken: getButtonToken
      });
    })();
  }, [isAccessButtonEnabled, colourScheme]);

  return (
    <div className="AccessHeaderLogo flex flex-row flex-nowrap justify-start content-stretch items-center max-[480px]:hidden">
      {connectionStatus === "none" && (
        <div className="OfflineIndicator group relative w-14 h-9 flex items-center justify-center hover:bg-[var(--offlineIndicatorBackground)] hover:rounded">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18.866"
            height="18"
            viewBox="0 0 18.866 18"
          >
            <path
              id="offline"
              d="M20.772,3.986a.675.675,0,0,0-.464.2L3.664,20.834a.675.675,0,1,0,.954.954l7.5-7.5a1.329,1.329,0,0,0,.344.051,1.348,1.348,0,0,0,1.35-1.35,1.329,1.329,0,0,0-.051-.344l2-2a4.064,4.064,0,0,1-.4,5.17.675.675,0,0,0,.009.954.675.675,0,0,0,.954-.009,5.418,5.418,0,0,0,.4-7.08l1.842-1.842a7.666,7.666,0,0,1-.017,10.313.675.675,0,1,0,.993.914,9.023,9.023,0,0,0,0-12.16c-.007-.008-.016-.013-.023-.02l1.745-1.745a.675.675,0,0,0-.49-1.158ZM5.856,6.69a.669.669,0,0,0-.468.217,9.03,9.03,0,0,0-.823,11.119l.972-.972a7.68,7.68,0,0,1,.842-9.23A.676.676,0,0,0,5.856,6.69ZM9.083,9.013a.673.673,0,0,0-.475.2A5.429,5.429,0,0,0,7.5,15.094l1.066-1.066A4.044,4.044,0,0,1,9.571,10.16a.674.674,0,0,0-.488-1.147Z"
              transform="translate(-3.031 -3.986)"
              fill="#ffb42e"
            />
          </svg>
          <div className="OfflineIndicatorContent hidden absolute top-[33px] mt-[var(--safe-area-inset-top,0px)] bg-[var(--offlineIndicatorContentBackground)] shadow-lg z-[2] p-2 rounded group-hover:flex group-hover:items-center group-hover:justify-center text-[length:var(--offlineIndicatorContentFontSize)]">
            <div className="ArrowUp"></div>
            Last sync: {lastSyncForOfflineIndicator}
          </div>
        </div>
      )}
      {isAccessButtonEnabled ? (
        <div
          id="access_button"
          className="flex items-center justify-start h-full w-[142px]"
        />
      ) : (
        <>
          {!isNativeTab() && (
            <>
              {colourScheme === "dark" && (
                <img
                  src={AccessCollinsLogo}
                  alt="logo"
                  className="AccessLogo w-[200px]"
                />
              )}
              {colourScheme === "light" && (
                <img
                  src={AccessCollinsLogoBlack}
                  alt="logo"
                  className="AccessLogo w-[200px]"
                />
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};
